import { useGetEntityOwnerData } from "./entity";
import { useSenderEmailGate } from "./useSenderEmailGate";
import { usePermissions, PlanTier } from "../utils/permissions";
import { IUser } from "../contexts/types";

export type HomeAttentionReason = "senderEmail" | "smsCredit";

export type HomeAttention = {
  needsAttention: boolean;
  reasons: HomeAttentionReason[];
};

const SMS_CREDIT_WARNING_THRESHOLD = 500;

export const useHomeAttention = (
  customer_identification: string,
  entity_identification: string,
  user: IUser,
  options?: { enabled?: boolean }
): HomeAttention => {
  const enabled = options?.enabled ?? true;
  const permissions = usePermissions(user);
  const isPromoTrial = permissions.isPromoTrial();
  const isAtLeastPremium =
    permissions.isAtLeastTier(PlanTier.PREMIUM) && !isPromoTrial;

  const senderGate = useSenderEmailGate(
    customer_identification,
    entity_identification,
    { enabled }
  );

  const { data: smsEntityData, isLoading: isSmsLoading } =
    useGetEntityOwnerData(
      customer_identification,
      entity_identification,
      "sms_credit",
      {
        enabled:
          enabled &&
          isAtLeastPremium &&
          !!customer_identification &&
          !!entity_identification,
      }
    );

  const reasons: HomeAttentionReason[] = [];

  if (!isPromoTrial && !senderGate.isLoading && !senderGate.canSend) {
    reasons.push("senderEmail");
  }

  if (isAtLeastPremium && !isSmsLoading) {
    const smsCredit = smsEntityData?.entity_other_data?.sms_credit;
    if (smsCredit == null || smsCredit < SMS_CREDIT_WARNING_THRESHOLD) {
      reasons.push("smsCredit");
    }
  }

  return {
    needsAttention: reasons.length > 0,
    reasons,
  };
};
